import PropTypes from 'prop-types';
import styles from './header.module.scss';
import useWebView from '../../hooks/useWebView';
import Logo from './logo/logo';
import Menu from './menu/menu';

export default function Header({
  logo = {},
  navigation = [],
  signInData = {},
  type = null,
}) {
  const isWebView = useWebView();

  if (isWebView) {
    return null;
  }

  return (
    <>
      <header className={styles.header}>
        <div className={styles.wrapper}>
          <div className={styles.container}>
            {logo && <Logo logo={logo} type={type} />}
            <Menu navigation={navigation} signInData={signInData} type={type} />
          </div>
        </div>
      </header>
      <div className={styles.contentPadding} />
    </>
  );
}

Header.propTypes = {
  logo: PropTypes.object,
  navigation: PropTypes.array,
  signInData: PropTypes.object,
  type: PropTypes.string,
};
